import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import Breadcrumb from '@/components/Breadcrumb';
import { SKIP_LINK_TARGET } from '@/constants/accessibility';

// Memoized layout components
const MemoizedSidebar = memo(Sidebar);
const MemoizedHeader = memo(Header);
const MemoizedBreadcrumb = memo(Breadcrumb);

function AppLayoutComponent() {
  return (
    <div className="flex h-screen bg-gradient-to-br from-muted/30 via-background to-muted/20">
      <MemoizedSidebar />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <MemoizedHeader />
        <main 
          id={SKIP_LINK_TARGET}
          className="flex-1 overflow-auto p-4 sm:p-6 lg:p-8"
          role="main"
          aria-label="Main content"
          tabIndex={-1}
        >
          <div className="max-w-7xl mx-auto">
            <MemoizedBreadcrumb />
            <div className="mt-4">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export const AppLayout = memo(AppLayoutComponent);
